import React from 'react'
import Card from './Card'
import image1 from '@/assets/images/Imagens/005-Titulo sobre o Senai.png'
import image2 from '@/assets/images/Imagens/005-Titulo sobre o Senai - 2.png'

const CardSection: React.FC = () => {
  // Seção removida conforme solicitado
  return null
}

export default CardSection
